import OutlineButton from '../Button/OutlineButton/OutlineButton'
import Label from '../Label'
import './MultiFileUpload.scss'
import close from '../../assets/images/Close_SuccessPopup.svg'
import EventHandler from '../EventHandler'

interface IProps {
  onChange?: any,
  noFiles?: boolean,
  file?: any,
  multiple?: boolean,
  value?:any,
  onDeleteFile?:any,
  onUploadClick?:any,
  isLoading?:any,
  index?:any,
  id?:any,
  uploadClickId?:any,
  onAddAttachments?:any,
  onDeleteAttachment?:any,
  setFileList?:any,
  fileList?:any,
  uploadErrMsg?:any,
  actionColumn?:any
}

const MultiFileUpload = ({ noFiles = true, file = '', multiple = false, value, onUploadClick,
id,onAddAttachments, onDeleteAttachment,setFileList,fileList,uploadErrMsg,actionColumn}: IProps) => {

  const dropArea = document.getElementById('drop-area');
  if (dropArea != undefined) {
    dropArea.addEventListener('dragover', (event) => {
      event.stopPropagation();
      event.preventDefault();
      if (event.dataTransfer)
        event.dataTransfer.dropEffect = 'copy';
    });

    dropArea.addEventListener('drop', (event) => {
      event.stopPropagation();
      event.preventDefault();
      if (event.dataTransfer) {
        const droppedFileList = event.dataTransfer.files;
        let files = [...droppedFileList]
        files.forEach((x: any, _i: any) => {
          fileList[0].push(x)
        })
        let arr1: any[] = [...fileList];
        arr1[0] = fileList[0]
        setFileList(arr1)
        event.stopImmediatePropagation();
      }
    });
  }

  return <>
    <div className='file-upload'>
    <div className='file-upload-wrapper'>
    {
      noFiles ? <span className='nofile-chosen'>Drag & Drop (or) Browse</span> : <span className='file-name'>{file}</span>
    }
    <input id="drop-area" type="file" value={value} name="myfile" className='file-upload' onChange={onAddAttachments} multiple={multiple}  data-attribute="index_myfile_Input_2" />
  </div>{
    <OutlineButton id = {id} onClick={onUploadClick} className='me-0 ms-2' data-attribute="index_Default_Button_5"><span className='fa fa-upload upload-icon'>
    </span> Upload</OutlineButton>
  }
    </div>
    <span className='asset-validation-msg'>{uploadErrMsg[0]}</span>

    {fileList?.[0] && fileList?.[0]?.map((item: any, index: any) => {

      return (
        <div>
          <div className={`${index == 0 ? 'fileList' : 'fileList-block'} `}>
            <div className='left-block'>
              <Label key={index} title={actionColumn == true ? (item.fileName || item.name) : item.name} data-attribute="index_Default_Label_2">{ actionColumn == true ? (item.fileName || item.name) : item.name}</Label>
              <div className='pull-right'>
                <EventHandler onEvent={() => { onDeleteAttachment(item, index) }} data-attribute={`index_${((item?.fileName || item?.name || index)).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Delete_EventHandler`}>
                  <img src={close} alt='close' className='close-btn-upload' />
                </EventHandler>
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </>
}

export default MultiFileUpload
